/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GET_ORGANIZATION } from "../pages/Organization/graphql/organiztion-detail.query";
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { humanize } from "uno-js";
import { data } from "./config/wallet-data"
import {GET_WALLET_BALANCE}  from "../pages/WalletScreen/graphql/get-wallet-balance.query";
import {providerTypeToChainType, providerTypeToChain} from '../utils/onchain-utils';

const MODULE_NAME = "WalletService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class WalletService {
    private static instance: WalletService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): WalletService {
        if (!WalletService.instance) {
            WalletService.instance = new WalletService(props);
        }
        return WalletService.instance;
    }

    getMeta = (data: any) => {
        if (data) {
            let _output: any = [];

            for (const [key, value] of Object.entries(data)) {
                if (
                    key === "fullAddress" ||
                    key === "email" ||
                    key === "telephone" ||
                    key === "website" ||
                    key === "owner"
                ) {
                    _output.push({
                        key: humanize(key.toString()),
                        value: value,
                    });
                } else if (key === "sameAs") {
                    _output.push({
                        key: humanize("website"),
                        value: value,
                    });
                }
            }
            return _output;
        }
    };

    _getNetwork(provider:string){
        let _provider = providerTypeToChainType(provider);
        let _network = providerTypeToChain(provider);
        if(_provider){
            return humanize(_provider) + " " + humanize(_network); 
        }

    }

    async getWallet() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient('graphql-gateway');
        try {
            if (client) {
                // const res = await client.query({
                //     query: GET_ORGANIZATION,
                //     fetchPolicy: "network-only",
                // });
                // log.success(MODULE_NAME, "getOrganization: ", res);

                // //return res?.data?.getMyOrganization;
                // return {
                //     organizationData: res?.data?.getMyOrganization,
                //     img: res?.data?.getMyOrganization?.logo,
                //     title: res?.data?.getMyOrganization?.name,
                //     description: res?.data?.getMyOrganization?.description,
                //     key: res?.data?.getMyOrganization?.fullAddress,
                //     meta: this.getMeta(res?.data?.getMyOrganization),
                // };

                try {
                    if (client) {
                        const res = await client.query({
                            query: GET_WALLET_BALANCE,
                            fetchPolicy:'network-only'
                        });
                        log.success(`wallet balance`, res);
                        let _res = {
                            ...res?.data,
                           data: {
                            img: "https://i.ibb.co/gF0SwzQ/profile.png",
                                meta:[{
                                    key:"Address",
                                    value:res?.data?.getMyBalance?.address
                                  },
                                  {
                                    key: "Network",
                                    value:this._getNetwork(res?.data?.getMyBalance?.provider_type),
                                  },
                                  {
                                    key: "Wallet Name",
                                    value: "Sling Wallet",
                                  },
                                  {
                                    key: "Wallet Description",
                                    value: "Sling managed wallet",
                                  },
                                ],
                            }
                           
                          
                        }
                        if(res?.data){
                            return _res;
                        }
                       
                    }
                    // return true;
                } catch (err: any) {
                    return err;
                }
                // console.log("in org wallet service",data)
                // return data
            }
          
        } catch (err) {
            console.log(`error in getOrganization=>`, err);
        }
    }
}
